// Tooltip.tsx
import styles from "./styles.module.scss";

type TooltipProps = {
  x: number;
  y: number;
  text: string;
  visible: boolean;
  keys?: string[];
};

export function Tooltip({ x, y, text, visible,keys = ["ctrl",'z'] }: TooltipProps) {
  return (
    <div
      className={styles.tooltip}
      style={{
        top: y,
        left: x,
        opacity: visible ? 1 : 0,
        transform: visible ? "translate(-50%, 6px)" : "translate(-50%, 0)",
      }}
    >
      {text}
      <div className="keys">
        {keys.map((key)=>(
            <span className={styles.key}>{key}</span>
        ))}
      </div>
    </div>
  );
}
